import React from 'react'
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import IconButtonUI from '../../widgets/action/IconButtonUI'
import TextInputSF from '../../widgets/input/TextInputSF'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
//import './OpenAIPage.css'

const OpenAIPageUI = ({context, errorList, onSubmit, textList, onRefreshClick}) =>
  <PrivatePageSF context={context} className='pg_openai' topnav='openai' headerText='Open AI'
     centered={!errorList && false}
  >
    {
      !errorList && false &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }

    <TextInputSF onSubmit={onSubmit} />

    {
      textList.map((text, i) =>
        <div className='g_m_top_100' key={i}>
          {text}
        </div>
      )
    }

    {/*
        <div className='g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
        </div>
    */}
  </PrivatePageSF>

export default OpenAIPageUI
